import React, { Component } from 'react';
import './style.scss';
class SlideUpDialog extends Component {
    render() {
        const {
            isOpen,
            className,
            onClose,
            children,
            maxHeight
        } = this.props;
        return (
                <div className={isOpen ? `${className || ""} slide-up-dialog` : `${className || ""} slide-up-dialog close`} >
                    <div className='slide-up-dialog-overlay' onClick={onClose} />
                    <div className="slide-up-dialog-items" style={{maxHeight}}>
                        {children}
                    </div>
                </div>
        );
    }
}


export default SlideUpDialog